import { Grid } from '@mui/material';
import React from 'react';

export const Loader = (props) => {

    return props.show ?
        <Grid className={"loader"} ml={2} style={{ width: props.size, height: props.size }} ></Grid>
        : <Grid> </Grid>

}